import { css } from 'lit';

export const buttonMaterial = css`
  .jr-button-material {
    width: 100%;
    color: #fff;
    border: none;
    height: 45px;
    display: block;
    cursor: pointer;
    font-size: 18px;
    font-weight: 600;
    line-height: 21px;
    text-align: center;
    border-radius: 5px;
    padding: 12.5px 24px;
    background-color: #ff206e;
    text-transform: uppercase;
  }
  .jr-button-material:hover {
    background-color: #ff538f;
    text-decoration: none;
  }
  .spinner {
    width: 100%;
    height: 45px;
    x: 0px; y: 0px;
    border-radius: 5px;
    padding: 8px 24px;
    background-size: 30px;
    background-color: #ff206e;
  }
  
  circle {
    animation: circle-animation 1s infinite linear;
    display: block;
    fill: transparent;
    stroke: #ffffff;
    stroke-linecap: round;
    stroke-dasharray: 164.93361431346415 56.97787143782138;
    stroke-width: 10;
    transform-origin: 50% 50%;
  }
  
  @keyframes circle-animation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @media (min-width: 768px) {
    .jr-button-material,
    .spinner {
        height: 40px;
        padding: 6px 24px;
    }
  }
`;